import request from '@/utils/request'

export function getPay(id) {
  return request({
    url: 'provider/getPay/' + id,
    method: 'get'
  });
}

export function getDocumentById(id) {
  return request({
    url: 'document/getDocumentById/' + id,
    method: 'get'
  });
}

export function saveDocument(data) {
  return request({
    url: 'document/store',
    method: 'post',
    data
  });
}

export function getDocumentPay(payment_id, consecutive) {
  return request({
    url: 'document/getDocumentPay/' + payment_id + '/' + consecutive,
    method: 'get'
  });
}

export function searchProduct(data) {
  return request({
    url: 'document/searchProduct',
    method: 'post',
    data
  });
}
export function searchCupon(number) {
  return request({
    url: 'document/searchCupon/' + number,
    method: 'get',
  });
}

export function getDocumentsToday(id) {
  return request({
    url: 'document/getDocumentsToday/' + id,
    method: 'get',
  });
}

export function getDocumentForPay(payment_id, consecutive) {
  return request({
    url: 'document/getDocumentForPay/' + payment_id + '/' + consecutive,
    method: 'get',
  });
}
